import { FC, useEffect } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { DropdownField, useFormField } from '@frontend/design-system';

type Option = { id: string; label: string };

interface Props {
  isSmallMode?: boolean;
  label: string;
  onChange: (value: string) => void;
  options: Option[];
  placeholder?: string;
  trackingId?: string;
  value?: string;
}

export const DropDownSelector: FC<React.PropsWithChildren<Props>> = ({
  isSmallMode,
  label,
  onChange,
  options,
  placeholder,
  trackingId,
  value,
}) => {
  const fieldProps = useFormField(
    {
      type: 'dropdown',
      value,
    },
    [value]
  );

  useEffect(() => {
    if (fieldProps.value !== value) onChange(fieldProps.value);
  }, [fieldProps.value]);

  return (
    <DropdownField
      {...fieldProps}
      className={isSmallMode ? 'small-mode' : 'large-mode'}
      css={styles}
      data-trackingid={trackingId}
      label={label}
      name={label}
      placeholder={placeholder}
    >
      {options.map(({ id, label }) => (
        <DropdownField.Option key={id} value={id}>
          {label}
        </DropdownField.Option>
      ))}
    </DropdownField>
  );
};

const styles = css`
  font-size: ${theme.fontSize(14)};
  width: auto;
`;
